import { render, staticRenderFns } from "./TablaTiposDescuentos.vue?vue&type=template&id=ec873afa"
import script from "./TablaTiposDescuentos.vue?vue&type=script&lang=js"
export * from "./TablaTiposDescuentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports